<template>
  <list
    v-if="$store.state.user.sections['variants']"
    :columns="columns"
    :modalCreate="modalCreate"
    :staticFilters="staticFilters"
    :removeLink="removeLink"
    :cardLink="cardLink"
    :isUpdate="true"
    :isAdd="true"
    :itemLink="itemLink"
    :setLink="setLink"
    :openItem="true"

    :fields="fields"
    :params="params"

    :searchDisable="true"
    @change="change"
    @changeFunction="changeFunction"
    v-model="val"
  />
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
  
      staticFilters: [],
      params: {
        per_page: 20,
        show: 1,
      },
      val: [],
      modalCreate: "season",
      fields: [
        {
          col: "col-12",
          label: "Название",
          key: "name",
          type: "field",

        },

        {
          col: "col-12",
          label: "Категории",
          key: "categories",
          type: "selects",
          modal: "subcategory",
          selectKey: "name",
        },
        {
          col: "col-12",
          label: "Бренд",
          key: "brand",
          type: "select",
          modal: "brand",
          selectKey: "name",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_product",
      itemLink: "products",
      setLink: "products",
      columns: [
        {
          key: "id",
          title: "id",
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
    
        },
        {
          key: "brand",
          title: "Бренд",
          disableLink: true,
          checkbox: false,
          control: false,
          object: "name",
          timer: false,
          detail: false,
        },
        {
          key: "name",
          full: true,
          title: "Название",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },
        {
          key: "vendor_code",
          title: "Артикул",
          disableLink: true,
          checkbox: false,
          control: false,
          align: "left",
          timer: false,
          detail: false,
        },

        {
          detail: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
